import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../models/address';

@Pipe({
  name: 'address',
})
export class AddressPipe implements PipeTransform {
  /**
   * 
   */
  transform(value: string, addresses: Address[]) {
    var x = addresses.find(x => x.uuid == value);
    return `${x.street} ${x.number}`;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/address/address.ts